import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observable, of, map } from 'rxjs';
import { ContactSummary, ContactType, Entity, BillAccount, InvoiceDisplayMode } from '@jms/model';
import { PickerFetch } from '@jms/ui/ui.core.pickers/src/components';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import * as Enumerable from 'linq';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { PickerItemModule } from '@jms/ui/ui.picker.item';
import { HttpClient } from '@angular/common/http';
import { EntityItemModule } from '../entity.item';

@Component({
    selector: 'bill-account-picker',
    templateUrl: './bill.account.picker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: BillAccountPickerComponent, multi: true }
    ],
    standalone: false
})
export class BillAccountPickerComponent extends PickerBaseComponent implements OnInit {

  @Input() public data: BillAccount[];
  @Input() public placeholder = '<Account>';
  @Input() public contractorId: string = null;
  @Input() public displayMode = InvoiceDisplayMode.WorkOrder;

  public data$: Observable<BillAccount[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public async ngOnInit() {

    super.ngOnInit();

    const data$ = this.fetch === PickerFetch.Automatic
      ? this.getAccounts()
      : of(this.data);

    this.data$ = data$
      .pipe(
        map((items: BillAccount[]) => {

          return Enumerable
            .from(items)
            .select((e: any) => {



              e.groupType = e.type === ContactType.Subcontractor
                ? 'Contractor(s)'
                : `${e.type}(s)` as any;

              return e;
            })
            .orderBy(e => e.type)
            .thenBy(e => e.name)
            .toArray();

        })
      );

  }


  private getAccounts(): Observable<BillAccount[]> {

    switch (this.displayMode) {
      case InvoiceDisplayMode.WorkOrder: {
        return this.http.get<Entity[]>(`/api/picker/contact/bill/contractor/${this.contractorId}`);
      }
      case InvoiceDisplayMode.Global: {
        return this.http.get<Entity[]>(`/api/picker/contact/bill/all`);
      }
    }


  }


}


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
    EntityItemModule
  ],
  declarations: [
    BillAccountPickerComponent
  ],
  providers: [],
  exports: [
    BillAccountPickerComponent
  ],
})
export class BillAccountPickerModule { }